// src/components/Admin/AdminDashboard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './AdminStyles.css';

const AdminDashboard = () => {
  return (
    <div className="admin-dashboard">
      <h2>Painel de Admin</h2>
      <nav>
        <Link to="/admin/inserir" className="admin-link">
          Inserir Link
        </Link>
        <Link to="/admin/editar" className="admin-link">
          Editar Link
        </Link>
        <Link to="/admin/excluir" className="admin-link">
          Excluir Link
        </Link>
      </nav>
    </div>
  );
};

export default AdminDashboard;